export default "__VITE_ASSET__Bh__z$Dg__"